import { QueryClient } from '@tanstack/react-query';
import { onAuthSessionChange } from './authSession';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 2,
      refetchOnWindowFocus: true,
      staleTime: 0,
      gcTime: 10 * 60 * 1000,
      refetchOnMount: true,
    },
  },
});

onAuthSessionChange(() => {
  void queryClient.cancelQueries();
  queryClient.clear();
});
